<script lang="ts">
	import type { CloudRecording } from '../types/cloud-recordings';
	import { onMount } from 'svelte';
	import { getCloudRecordings } from 'src/services/cam-cloud/recordings';
	import { Loader, Scroll, Stack, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { camera_previews } from 'src/stores/features/cameras/previews';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import RecordingsListItemV2 from './RecordingsTab/RecordingsListItemV2.svelte';
	import NoResults from './RecordingsTab/NoResults.svelte';

	export let deviceId: string;

	const RECORDINGS_LIMIT = 3;

	let recordings: CloudRecording[] = [];
	let isLoading = true;

	$: devicePreview = $camera_previews[deviceId];
	$: if (devicePreview) loadRecordings();

	const loadRecordings = async () => {
		try {
			const result = await getCloudRecordings(deviceId, { limit: RECORDINGS_LIMIT, offset: 0 });
			recordings = result.items as CloudRecording[];
		} catch (error) {
			console.log('Failed to load recordings', error);
		} finally {
			isLoading = false;
		}
	};

	const handleSelect = (event: CustomEvent<CloudRecording>) => {
		const recording = event.detail;
		routeToDeviceSettings.setTarget(deviceId, 'camera_recordings', 'view', recording as any);
	};

	onMount(loadRecordings);
</script>

<div class="mt-l mb-m">
	<Text element="p" styleType="label-large" class="mb-s text-uppercase text-color-muted text-center">
		{$format('last_recordings_title', { default: 'Last Events' })}
	</Text>

	{#if isLoading}
		<div class="d-flex justify-content-center width-full p-m">
			<Loader />
		</div>
	{:else if recordings.length > 0}
		<Scroll smallerScroll>
			<Stack gap="s">
				{#each recordings as recording (recording.id)}
					<RecordingsListItemV2
						{recording}
						selected={false}
						variant="simple"
						on:select={handleSelect}
					/>
				{/each}
			</Stack>
		</Scroll>
	{:else}
		<div class="pb-l">
			<NoResults />
		</div>
	{/if}
</div>
